import { useEffect, useMemo, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from '@lean-body/src/route';
// scriptタグの挿入と削除をコンポーネントのマウント/アンマウントで制御する
export const useScript = (url, callback) => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = url;
        script.onload = callback;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, [url]);
};
// cssのlinkタグの挿入と削除をコンポーネントのマウント/アンマウントで制御する
export const useCss = (path) => {
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = path;
        document.head.appendChild(link);
        return () => {
            document.head.removeChild(link);
        };
    }, [path]);
};
// クエリパラメータを取得
// const query = useQuery()
// query.get("name")
export const useQuery = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
};
// ウィンドウのサイズを取得
// const windowSize = useWindowSize()
// windowSize.width
export const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });
    const handleResize = () => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    };
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return windowSize;
};
// ref.currentがnullのまま更新されないのを防ぐhooks
// const { ref, element } = useRefHooks<HTMLDivElement>()
export const useRefHooks = () => {
    const ref = useRef();
    const [element, setElement] = useState(ref.current);
    useEffect(() => {
        setElement(ref.current);
    }, [ref.current]);
    return { ref, element };
};
// Mountedの判定をする
// isMounted = useIsMounted()
export const useIsMounted = () => {
    const componentIsMounted = useRef(true);
    useEffect(() => {
        return () => {
            componentIsMounted.current = false;
        };
    }, []);
    return componentIsMounted;
};
// ロケーションの変更を検知
export const useLocationChange = (callback) => {
    const callbackRef = useRef();
    const location = useLocation();
    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);
    useEffect(() => {
        if (callbackRef.current) {
            callbackRef.current(location);
        }
    }, [location]);
};
// 指定した秒数(duration)で指定した値（max）までインクリメントする
export const useIncrement = (duration, max, setValue) => {
    useEffect(() => {
        const interval = 10;
        const totalIncrements = duration / interval;
        const increment = max / totalIncrements;
        setValue(0);
        const id = setInterval(() => {
            setValue((prev) => {
                if (prev + increment >= max) {
                    clearInterval(id);
                    return max;
                }
                return prev + increment;
            });
        }, interval);
        return () => clearInterval(id);
    }, [max]);
};
// 前のページに戻る。前のルートがリーンボディではない場合、TOPに戻る
export const useNavigateBack = () => {
    const navigate = useNavigate();
    const location = useLocation();
    return () => {
        if (location.key !== 'default') {
            navigate(-1);
        }
        else {
            navigate(routes.TOP.compile());
        }
    };
};
